export const CREATE_DRAFT = 'mallBonusCreatePage/CREATE_DRAFT';

export const FETCH_ITEM = 'mallBonusCreatePage/FETCH_ITEM';

export const GO_TO_STEP_ONE = 'mallBonusCreatePage/GO_TO_STEP_ONE';

export const GO_TO_STEP_TWO = 'mallBonusCreatePage/GO_TO_STEP_TWO';

export const SUBMIT = 'mallBonusCreatePage/SUBMIT';
